__turbopack_context__.v({
  "btn_submit": "address-module__OXDkWa__btn_submit",
  "container": "address-module__OXDkWa__container",
});
